module.exports = __webpack_public_path__ + "img/slider-h.1627ea37.png";